import { Component } from '@angular/core';
import { GraphService } from '../services/graph.service';

@Component({
    selector: 'app-pim',
    templateUrl: './pim.component.html',
    styleUrl: './pim.component.scss',
    standalone: false
})
export class PimComponent {

  constructor(private _g: GraphService) {
    // this._g.getAvailableRoles().subscribe((data) => {
    //   console.log('Available roles:', data);
    // });
  }

  ngOnInit() {
    this._g.getAvailableRoles().subscribe((data) => {
      console.log('Available roles:', data);
    });
  }

}
